import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import pageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...pageManagerConfigurationBase.detailsPageMap,
            "ProcessVersion": async () => (await import("./Pages/Entities/ProcessVersions/ProcessVersionDetailsPage")).ProcessVersionDetailsPage,
        },
        indexPageMap: {
            ...pageManagerConfigurationBase.indexPageMap,
        },
        routes: {
            ...pageManagerConfigurationBase.routes,
            "/modules/processes/dashboard/": async () => (await import("./Pages/ProcessDashboardPage")).ProcessDashboardPage,
            "/modules/processes/designer/{recordId}/": async () => (await import("./Pages/ProcessDesignerPage")).ProcessDesignerPage,
            "/modules/processes/mytasks/": async () => (await import("./Pages/TasksPage")).TasksPage,
            "/modules/processes/tasks/": async () => (await import("./Pages/TasksPage")).TasksPage,
        }
    };

export default configuration;